import JsCookie from "js-cookie"

import type { CookieKey, CookieValue } from "@/constants/cookies"

import { Cookies } from "@/constants/cookies"

class CookieService {
  private static instance: CookieService | null = null

  public static getInstance(): CookieService {
    if (!this.instance) {
      this.instance = new CookieService()
    }
    return this.instance
  }

  public get<T extends CookieKey>(key: T): CookieValue<T> {
    return (JsCookie.get(Cookies[key].key) ?? Cookies[key].defaultValue) as CookieValue<T>
  }

  public set<T extends CookieKey>(key: T, value: CookieValue<T>): void {
    JsCookie.set(Cookies[key].key, value, { expires: Cookies[key].expires })
  }

  public remove<T extends CookieKey>(key: T): void {
    JsCookie.remove(Cookies[key].key)
  }

  public getCustom(key: string): string | undefined {
    return JsCookie.get(key)
  }

  public setCustom(key: string, value: string): void {
    JsCookie.set(key, value)
  }
}

export const cookieService = CookieService.getInstance()
